<tp-modal-template [showCloseIcon]="false">
  <angular-cropper #angularCropper [cropperOptions]="config" [imageUrl]="data.imageUrl">
  </angular-cropper>

  <div class="modal-template__footer cropper-dialog__footer flex flex--just-center">
    <button class="tp-btn tp-btn--secondary m-r-3" matDialogClose>
      Cancel
    </button>
    <button class="tp-btn tp-btn--primary-green" (click)="save()">
      Save
    </button>
  </div>
</tp-modal-template>
